import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withModifiers as _withModifiers, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "p-6 border" }
const _hoisted_2 = {
  class: "flex flex-row justify-between items-start",
  id: "dialog-header"
}
const _hoisted_3 = { class: "flex flex-row gap-4 py-2" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "h-6 w-6 bg-h-primary-800 rounded-sm mt-2" }, null, -1)
const _hoisted_5 = { class: "flex flex-col" }
const _hoisted_6 = { class: "flex flex-row items-center gap-4 text-sm" }
const _hoisted_7 = { class: "py-3" }
const _hoisted_8 = ["scale"]
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "flex flex-row items-center gap-2" }
const _hoisted_11 = { class: "flex flex-row items-center gap-2 py-2" }
const _hoisted_12 = { class: "text-sm text-h-neutral-700" }
const _hoisted_13 = {
  key: 1,
  class: "flex gap-2"
}
const _hoisted_14 = {
  key: 1,
  class: "pt-4 max-h-64 overflow-y-auto",
  id: "list-recorded-lives"
}
const _hoisted_15 = { class: "flex flex-col" }
const _hoisted_16 = { class: "pt-2" }
const _hoisted_17 = { class: "text-sm pb-2" }
const _hoisted_18 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_Divider = _resolveComponent("Divider")!
  const _component_ScheduleXCalendar = _resolveComponent("ScheduleXCalendar")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!
  const _directive_role = _resolveDirective("role")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_ScheduleXCalendar, { "calendar-app": _ctx.calendarApp }, {
      eventModal: _withCtx(({ calendarEvent }) => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("span", _hoisted_2, [
            _createElementVNode("span", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("span", _hoisted_5, [
                _createElementVNode("h5", null, _toDisplayString(calendarEvent.title), 1),
                _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.utils.formatDate(calendarEvent.start)), 1)
              ])
            ]),
            _withDirectives(_createVNode(_component_Button, {
              icon: "pi pi-trash",
              class: "btn-delete",
              onClick: _withModifiers(($event: any) => (_ctx.confirmDelete(calendarEvent?.id)), ["prevent"])
            }, null, 8, ["onClick"]), [
              [_directive_role, ['TEACHER']]
            ]),
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.eventModal.close && _ctx.eventModal.close(...args)), ["prevent"])),
              class: "py-3"
            }, [
              _createVNode(_component_v_icon, {
                name: "io-close-outline",
                scale: 1.2
              }, null, 8, ["scale"])
            ])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("p", _hoisted_7, [
              _createVNode(_component_v_icon, {
                name: "hi-solid-user-circle",
                scale: 1.2
              }, null, 8, ["scale"]),
              _createTextVNode(" " + _toDisplayString(calendarEvent.owner), 1)
            ]),
            (calendarEvent.videos?.length === 0)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: "pb-6 flex flex-row items-center gap-2",
                  scale: 1.2
                }, [
                  (!_ctx.isDeprecatedClass(calendarEvent))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                          _createVNode(_component_v_icon, { name: "bi-camera-video" }),
                          _createVNode(_component_Button, {
                            class: "btn-primary",
                            label: 
                      _ctx.$t('labels.generic', {
                        pt: 'Junte-se à turma na aula',
                        en: 'Join with class in the meeting',
                      })
                    ,
                            onClick: ($event: any) => (_ctx.goToLiveClass(calendarEvent?.url))
                          }, null, 8, ["label", "onClick"])
                        ]),
                        _createElementVNode("div", _hoisted_11, [
                          _createVNode(_component_v_icon, {
                            name: "md-copyall",
                            onClick: ($event: any) => (_ctx.copyLink(calendarEvent?.url)),
                            class: "cursor-pointer"
                          }, null, 8, ["onClick"]),
                          _createElementVNode("p", _hoisted_12, _toDisplayString(calendarEvent?.url), 1)
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _createVNode(_component_v_icon, { name: "bi-calendar-x" }),
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t("labels.generic", {
                      pt: "Aula encerrada",
                      en: "Finished class",
                    })), 1)
                      ]))
                ], 8, _hoisted_8))
              : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createVNode(_component_Divider, {
                    align: "center",
                    type: "solid"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("h6", null, _toDisplayString(_ctx.$t("labels.generic", {
                      pt: "Lista de aulas gravadas",
                      en: "Recorded classes list",
                    })), 1)
                    ]),
                    _: 1
                  }),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(calendarEvent.videos, (video, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: video?.id
                    }, [
                      _createElementVNode("span", _hoisted_15, [
                        _createElementVNode("span", null, [
                          _createElementVNode("h6", _hoisted_16, _toDisplayString(_ctx.$t("labels.generic", {
                          pt: `Vídeo ${index + 1}`,
                          en: `Video ${index + 1}`,
                        })), 1),
                          _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.formatVideoDownloadDate(video.upload_date)), 1)
                        ]),
                        _createVNode(_component_Button, {
                          id: `download-button-${video.id}`,
                          label: 
                      _ctx.$t('labels.generic', {
                        pt: `Download `,
                        en: `Download `,
                      })
                    ,
                          loading: _ctx.btnLoading[index],
                          icon: "pi pi-download",
                          iconPos: "right",
                          "aria-hidden": "true",
                          onClick: _withModifiers(($event: any) => (
                      _ctx.downloadClassRecorded(video.video_url, video.id, index)
                    ), ["prevent"]),
                          class: "btn-primary"
                        }, null, 8, ["id", "label", "loading", "onClick"])
                      ])
                    ]))
                  }), 128))
                ])),
            (calendarEvent.isPublic)
              ? (_openBlock(), _createElementBlock("p", _hoisted_18, [
                  _createVNode(_component_v_icon, { name: "hi-lock-closed" })
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }, 8, ["calendar-app"]),
    _createVNode(_component_ConfirmDialog, { class: "w-[80vw] max-w-[700px]" })
  ]))
}